module.exports = __webpack_public_path__ + "img/1-zh.91c97ee8.png";